import React from "react";
import { ErrorMessageContainer } from "./index.styled";

interface ErrorMessageProps {
  message: string | null;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
  if (!message) {
    return null;
  }

  return <ErrorMessageContainer>{message}</ErrorMessageContainer>;
};

export default ErrorMessage;
